import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getCatalogs () {
   return Api().get("/catalogs");
},
  updateCatalog (params) {
    return Api().put("/catalogs",params);
  },
  addCatalog (params) {
    return Api().post("/catalogs",params);
  },
  getCatalog (params) {
    return Api().get("/catalogs/"+params);
  },
  deleteCatalog (params) {
    return Api().delete("/catalogs/"+params);
  },
  findByType (params) {
    return Api().get("/findByType/"+params);
  },
  findChildren (params) {
    return Api().get("/findChildren/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/CatalogService.js